import { render, staticRenderFns } from "./static-vehicle-navigation-block.vue?vue&type=template&id=8c0d9ad6&"
import script from "./static-vehicle-navigation-block.vue?vue&type=script&lang=js&"
export * from "./static-vehicle-navigation-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports